/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createOrUpdateNotificationModelSchema } from "../createOrUpdateNotificationModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

/**
 * @description Идентификатор созданного уведомления
 */
export const postApiNotifications200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Push уведомление уже существует (заголовок или тип отправки при первом входе)
 */
export const postApiNotifications400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiNotifications401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiNotifications403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiNotifications500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const postApiNotificationsMutationRequestSchema = z.lazy(() => createOrUpdateNotificationModelSchema).describe("Тело запроса")

export const postApiNotificationsMutationResponseSchema = z.lazy(() => postApiNotifications200Schema)